import React from "react";
import WelcomePollComponent from "components/TeamPoll/WelcomePollComponent/WelcomePollComponent.js";

export default () => {
  
  return (
    <div className="col-lg-6 middle-content px-3">
      <div className="mainRootContainer">
        <WelcomePollComponent />
      </div>
    </div>
  );
};
